import axios        from 'axios';
import authHeader   from 'services/auth-header';

class NotificationService  {
  notifications(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'notifications', { headers: authHeader(), params: params })
      .then(response => {
        return response.data;
      }
    );
  }

  updateRead(params){
    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + 'notifications/read', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new NotificationService();